import React, { useEffect, useState, Fragment, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { Box, CircularProgress } from "@material-ui/core"
import styles from "./styles"
import PostSettings from "components/SideBox/components/PostSettings"
import IntegrationTextFields from "./IntegrationTextFields"
import IntegrationConnections from "./IntegrationConnections"
import PagesGrid from "../../../../components/PagesGrid"
import UpdateCardInfoDialog from "./UpdateCardInfo"
import { getLinkedInOrgs } from "actions/linkedIn"
import { openSnackBar } from "actions/snack-bar"
import { link } from "global-prefix"

const urlParams = new URLSearchParams(window.location.search)
const linkedinconnected = urlParams.get("linkedinconnected")

const Settings = () => {
  const org = useSelector(state => state.organization.currentOrg)
  const dispatch = useDispatch()
  const [cardInfoOpen, setCardInfo] = useState(false)
  const { linkedinPages } = useSelector(state => state.organization.currentOrg)
  useEffect(() => {
    if (org.bad_stripe) {
      setCardInfo(true)
    }
  }, [org])
  useMemo(() => {
    if (linkedinconnected) {
      dispatch(getLinkedInOrgs())
        .then(res => {
          if (linkedinPages === null) {
            location.reload()
          }
          // const response = JSON.parse(res.text)
          // dispatch(openSnackBar({ message: response.message }))
        })
        .catch(error => {
          dispatch(openSnackBar({ message: "Error updating user role" }))
        })
    }
  }, [linkedinPages])

  const isMobile = window.innerWidth < 800
  return (
    <Fragment>
      <PagesGrid
        content={
          org.id ? (
            <IntegrationTextFields
              isMobile={isMobile}
              org={org}
              setCardInfo={setCardInfo}
            />
          ) : (
            <Box display="flex" alignItems="center" justifyContent="center">
              <CircularProgress color="primary" />
            </Box>
          )
        }
        sideBox={
          !isMobile && (
            <Box>
              <PostSettings org={org} />
              {/* <Notifications /> */}
              <IntegrationConnections />
            </Box>
          )
        }
        noGrid
      />
      <UpdateCardInfoDialog
        open={cardInfoOpen}
        close={() => setCardInfo(false)}
      />
    </Fragment>
  )
}

export default withStyles(styles)(Settings)



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/index.jsx